import { Component } from '@angular/core';

@Component({
    selector: 'app-partner-terms-31-july-2024',
    templateUrl: './partner-terms-31-july-2024.component.html',
    styleUrl: './partner-terms-31-july-2024.component.scss',
    standalone: false
})
export class PartnerTerms31July2024Component {

}
